export const cleanUsername = (username: string) => {
  // remove all characters that are not alphanumeric or underscore or dash or dot
  return username.replace(/[^a-zA-Z0-9_.@-]/g, '')
}

export const isGenericEmail = (email: string): boolean => {
  // Generic prefixes check
  const genericPrefixes = [
    'info@',
    'support@',
    'help@',
    'admin@',
    'no-reply@',
    'donotreply@',
    'do_not_reply@',
    'noreply@',
    'notify@',
    'notification@',
    'subscriptions@',
    'updates@',
    'service@',
    'alerts@',
    'accounts@',
    'billing@',
    'sales@',
    'marketing@',
    'customerservice@',
    'promotions@',
    'automated@',
    'auto@',
    'drive-shares-dm-noreply@',
  ]

  // Generic domains check
  const genericDomains = [
    '@mailer.',
    '@email.',
    '@news.',
    '@updates.',
    '@marketing.',
    '@newsletter.',
    '@crm.',
    '@automations.',
    '@transactional.',
    '@googlemail.com',
    '@google.com',
  ]

  // Check if email starts with any generic prefix
  if (
    genericPrefixes.some((prefix) => email.toLowerCase().startsWith(prefix))
  ) {
    return true
  }

  // Check if email contains any generic domain
  if (genericDomains.some((domain) => email.toLowerCase().includes(domain))) {
    return true
  }

  return false
}

export const removeDuplicateEmails = <T extends { senderEmail: string }>(
  contacts: T[]
): T[] => {
  const seen = new Set()
  return contacts.filter((contact) => {
    const email = contact.senderEmail.toLowerCase()
    if (seen.has(email)) return false
    seen.add(email)
    return true
  })
}
